import { ThemeColor } from "../props";

// Muted background + near-neutral text. Used for colored containers (Panel, badges).
const _themeBackgroundStyles: Record<ThemeColor, string> = {
  none: "",
  primary: "bg-primary-50 dark:bg-primary-900/50",
  secondary: "bg-secondary-50 dark:bg-secondary-900/50",
  gray: "bg-back-100 dark:bg-back-800",
  error: "bg-error-50 dark:bg-error-900/50",
  warning: "bg-warning-50 dark:bg-warning-900/50",
  success: "bg-success-50 dark:bg-success-900/50",
  transparent: "bg-front-200/50 dark:bg-front-700/50",
  danger: "",
  alert: "",
  done: "",
};
_themeBackgroundStyles.danger = _themeBackgroundStyles.error;
_themeBackgroundStyles.alert = _themeBackgroundStyles.warning;
_themeBackgroundStyles.done = _themeBackgroundStyles.success;

// Near-neutral text for use on muted colored backgrounds.
const _themeForegroundStyles: Record<ThemeColor, string> = {
  none: "",
  primary: "text-front-800 dark:text-front-100",
  secondary: "text-front-800 dark:text-front-100",
  gray: "text-front-800 dark:text-front-100",
  error: "text-front-800 dark:text-front-100",
  warning: "text-front-800 dark:text-front-100",
  success: "text-front-800 dark:text-front-100",
  transparent: "text-front-800 dark:text-front-100",
  danger: "",
  alert: "",
  done: "",
};
_themeForegroundStyles.danger = _themeForegroundStyles.error;
_themeForegroundStyles.alert = _themeForegroundStyles.warning;
_themeForegroundStyles.done = _themeForegroundStyles.success;

// Colored text for standalone elements on neutral backgrounds (icons, labels).
const _themeTextStyles: Record<ThemeColor, string> = {
  none: "",
  primary: "text-primary-500 dark:text-primary-600",
  secondary: "text-secondary-600 dark:text-secondary-500",
  gray: "text-front-400 dark:text-front-500",
  error: "text-error-500 dark:text-error-600",
  warning: "text-warning-500 dark:text-warning-600",
  success: "text-success-500 dark:text-success-600",
  transparent: "text-front-700 dark:text-front-200 opacity-50",
  alert: "",
  danger: "",
  done: "",
};
_themeTextStyles.alert = _themeTextStyles.warning;
_themeTextStyles.danger = _themeTextStyles.error;
_themeTextStyles.done = _themeTextStyles.success;


const _themeBorderStyles: Record<ThemeColor, string> = {
  primary: "border-primary-200 dark:border-primary-700",
  secondary: "border-secondary-200 dark:border-secondary-700",
  gray: "border-back-300 dark:border-back-600",
  error: "border-error-200 dark:border-error-700",
  warning: "border-warning-200 dark:border-warning-700",
  success: "border-success-200 dark:border-success-700",
  transparent: "border-front-200/50 dark:border-front-700/50",
  none: "border-transparent",
  danger: "border-error-200 dark:border-error-700",
  alert: "border-warning-200 dark:border-warning-700",
  done: "border-success-200 dark:border-success-700",
};

const _themeFocusRingStyles: Record<ThemeColor, string> = {
  none: "",
  primary: "focus:ring-primary-500 dark:focus:ring-primary-400 focus-within:ring-primary-500 dark:focus-within:ring-primary-400 focus-visible:ring-primary-500 dark:focus-visible:ring-primary-400",
  secondary: "focus:ring-secondary-500 dark:focus:ring-secondary-400 focus-within:ring-secondary-500 dark:focus-within:ring-secondary-400 focus-visible:ring-secondary-500 dark:focus-visible:ring-secondary-400",
  gray: "focus:ring-back-400 dark:focus:ring-back-500 focus-within:ring-back-400 dark:focus-within:ring-back-500 focus-visible:ring-back-400 dark:focus-visible:ring-back-500",
  error: "focus:ring-error-500 dark:focus:ring-error-400 focus-within:ring-error-500 dark:focus-within:ring-error-400 focus-visible:ring-error-500 dark:focus-visible:ring-error-400",
  warning: "focus:ring-warning-500 dark:focus:ring-warning-400 focus-within:ring-warning-500 dark:focus-within:ring-warning-400 focus-visible:ring-warning-500 dark:focus-visible:ring-warning-400",
  success: "focus:ring-success-500 dark:focus:ring-success-400 focus-within:ring-success-500 dark:focus-within:ring-success-400 focus-visible:ring-success-500 dark:focus-visible:ring-success-400",
  transparent: "focus:ring-front-400 dark:focus:ring-front-500 focus-within:ring-front-400 dark:focus-within:ring-front-500 focus-visible:ring-front-400 dark:focus-visible:ring-front-500",
  danger: "",
  alert: "",
  done: "",
};
_themeFocusRingStyles.danger = _themeFocusRingStyles.error;
_themeFocusRingStyles.alert = _themeFocusRingStyles.warning;
_themeFocusRingStyles.done = _themeFocusRingStyles.success;

export const themeBackgroundStyles = _themeBackgroundStyles;
export const themeForegroundStyles = _themeForegroundStyles;
export const themeTextStyles = _themeTextStyles;
export const themeBorderStyles = _themeBorderStyles;
export const themeFocusRingStyles = _themeFocusRingStyles;

export function getFocusRingStyles(color: ThemeColor): string {
  return themeFocusRingStyles[color];
}
